import { Component } from '@angular/core'
import { DefaultRowComponent } from '../default-row/default-row.component'
import { CustomTableService } from '../../service/custom-table.service'
import { AgreementStatus } from '../../../../../../models/enum/agreement.enum'

@Component({
    selector: 'app-price-agreement-history-row',
    templateUrl: './price-agreement-history-row.component.html',
    styleUrls: ['./price-agreement-history-row.component.scss'],
    standalone: false
})
export class PriceAgreementHistoryRowComponent extends DefaultRowComponent {
  constructor(private customTableService: CustomTableService) {
    super()
  }

  public showWhenPending(index: number): boolean {
    if (index == 0) {
      return true
    }
    const id = this.row[this.uid]
    const data = this.customTableService.dataSource[id]
    return data.state == AgreementStatus.PENDING
  }

  public onClick(control: any): void {
    this.customTableService.clicked(control, this.row)
  }
}
